import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, Platform, IonRouterOutlet } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {
  @ViewChild(IonRouterOutlet,{static:false}) routerOutlet: IonRouterOutlet;
  constructor(private router: Router,
              private alertCtrl: AlertController,
              private platform: Platform,
              private splashScreen: SplashScreen,
              private statusBar: StatusBar) {
                this.initializeApp();

          this.platform.backButton.subscribe(() => {
          if (this.routerOutlet && this.routerOutlet.canGoBack()) {
            this.routerOutlet.pop();
          } else if  (this.router.url === '/page/tabs/home') {
            this.presentAlertConfirm();
          } else if  (this.router.url === '/page/tabs/member') {
            this.presentAlertConfirm();
          } else if  (this.router.url === '/page/tabs/inbox') {
            this.presentAlertConfirm();
          } else if  (this.router.url === '/page/tabs/account') {
            this.presentAlertConfirm();
          } else if  (this.router.url === '/page/tabs/member/parent') {
            this.presentAlertConfirm();
          }  else if  (this.router.url === '/page/tabs/member/teacher') {
            this.presentAlertConfirm();
          }
      });
  }

  async presentAlertConfirm() {
    const alert = await this.alertCtrl.create({
      header: 'Konfirmasi',
      message: 'Apakah Anda Yakin Keluar Aplikasi ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ya',
          handler: () => {
            console.log('Confirm Okay');
            navigator['app'].exitApp()
          }
        }
      ]
    });
    await alert.present();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
